import React from 'react';

import {
    Box,
    Typography,
    Button,
} from "@mui/material";

import {
  StaticDatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

const AssignmentDate = ({ dueDate, setDueDate, setActiveStep }) => {

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleDateChange = (newDate) => {
        setDueDate(newDate);
    };

    const minDate = dayjs();

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 6, pt: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h5" sx={{ flexGrow: 1 }}>Set Due Date</Typography>
                </Box>
                <Typography variant="body1" sx={{ mb: 2, pl: '100px', pr: '100px' }}>
                    Choose a due date for the assignment.
                </Typography>

                <StaticDatePicker
                    displayStaticWrapperAs="desktop"
                    value={dueDate}
                    onChange={handleDateChange}
                    ToolbarComponent={() => null}
                    minDate={minDate}
                    slotProps={{textField: { variant: 'outlined' }}}
                />

                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 0, mb: 2 }}
                    onClick={handleNext}
                >
                    Continue
                </Button>
            </Box>
        </LocalizationProvider>
    );
};

export default AssignmentDate;
